import { render, staticRenderFns } from "./FlyAmericaStatus.vue?vue&type=template&id=fa366f2c&"
import script from "./FlyAmericaStatus.vue?vue&type=script&lang=js&"
export * from "./FlyAmericaStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports